// extracted by mini-css-extract-plugin
export default {"view-all-positioner":"styles__view-all-positioner___NpPyP","view-all-text":"styles__view-all-text___ZOGWe"};